import mutations from './dataManagementProcessPlace.mutations'
import actions from './dataManagementProcessPlace.actions'
import getters from './dataManagementProcessPlace.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
